import { render, staticRenderFns } from "./TheoryExamParticipantsList.vue?vue&type=template&id=55d53e51&scoped=true"
import script from "./TheoryExamParticipantsList.vue?vue&type=script&lang=ts"
export * from "./TheoryExamParticipantsList.vue?vue&type=script&lang=ts"
import style0 from "./TheoryExamParticipantsList.vue?vue&type=style&index=0&id=55d53e51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d53e51",
  null
  
)

export default component.exports